export const BASE_URL_ENV_CONSTANTS = {
  local: 'https://how-intranetsingular.app-dev.howdeniberia.com/',
  development: 'https://how-intranetsingular.app-dev.howdeniberia.com/',
  staging: 'https://how-intranetsingular.app-staging.howdeniberia.com/',
  production: 'https://intranet.app.howdeniberia.com/'
};
